import { render, staticRenderFns } from "./spider-halloween.vue?vue&type=template&id=3dacad97"
import script from "./spider-halloween.vue?vue&type=script&lang=js"
export * from "./spider-halloween.vue?vue&type=script&lang=js"
import style0 from "./spider-halloween.vue?vue&type=style&index=0&id=3dacad97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports